import { useEffect, useState } from "react";
import "../../toggle/toggle.css";

function Toggle({ basedomain, setIcontoolsField, removeIcontoolsField }) {
  const [isChecked, setChecked] = useState(false);
  const globalValue = 1;
  const localValue = 3;

  const handleChange = () => {
    setChecked(!isChecked);
    setIcontoolsField(0, "region_type", !isChecked ? globalValue : localValue);

    if (!isChecked) {
      removeIcontoolsField(0, "center_lon");
      removeIcontoolsField(0, "center_lat");
      removeIcontoolsField(0, "hwidth_lon");
      removeIcontoolsField(0, "hwidth_lat");
    } else {
      setIcontoolsField(0, "center_lat", 49.5);
      setIcontoolsField(0, "center_lon", 11.5);
      setIcontoolsField(0, "hwidth_lat", 22.5);
      setIcontoolsField(0, "hwidth_lon", 33.5);
    }
  };

  useEffect(() => { setChecked(basedomain.icontools.region_type === 1) }, [basedomain]);


  return (
    <div className={"toggle-wrapper domain-toggle-wrapper"}>
      <div className="toggle">
        <input
          type="checkbox"
          id={"toggle-domain-type"}
          className="toggleCheckbox"
          onChange={handleChange}
          checked={isChecked}
        />
        <label htmlFor={"toggle-domain-type"} className="toggleContainer">
          <div style={isChecked ? null : { color: "white" }}>Local</div>
          <div style={isChecked ? { color: "white" } : null}>Global</div>
        </label>
      </div>
    </div>
  );
}

export default Toggle;
